import { render, staticRenderFns } from "./ShtDashboard.vue?vue&type=template&id=70be1056&"
import script from "./ShtDashboard.vue?vue&type=script&lang=js&"
export * from "./ShtDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShtDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports